import { render, staticRenderFns } from "./ParticipantsGrid.vue?vue&type=template&id=06792c18"
import script from "./ParticipantsGrid.vue?vue&type=script&lang=js"
export * from "./ParticipantsGrid.vue?vue&type=script&lang=js"
import style0 from "./ParticipantsGrid.vue?vue&type=style&index=0&id=06792c18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports